<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card class="py-5">
          <v-toolbar flat>
            <v-col cols="12" class="px-0 py-5">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Distributor Sales
                    <div class="month-label">
                      {{
                        `${formatDate(this.dates[0])} - ${formatDate(
                          this.dates[1]
                        )}`
                      }}
                      Report
                    </div>
                  </v-toolbar-title>
                </div>
                <div class="ml-auto d-flex">
                  <!-- <v-row> -->
                  <!-- <v-col cols="6"> -->
                  <v-select
                    :items="types"
                    label="Select Type"
                    dense
                    class="mr-2 mt-2"
                    item-text="name"
                    item-value="value"
                    v-model="type"
                  ></v-select>
                  <!-- </v-col>
                    <v-col cols="6"> -->
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="dates"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" v-bind="attrs" v-on="on">
                        <v-icon class="mr-2">mdi-calendar</v-icon> Choose Dates
                      </v-btn>
                    </template>
                    <v-date-picker v-model="dates" range>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        :disabled="dates.length <= 1"
                        color="primary"
                        @click="selectedDates(dates)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                  <!-- </v-col> -->
                  <!-- </v-row> -->
                </div>
              </div>
            </v-col>
            <!-- <v-spacer></v-spacer> -->
          </v-toolbar>

          <!-- <v-divider></v-divider> -->
        </v-card>
      </v-col>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    List
                  </v-toolbar-title>
                </div>
                <div class="ml-auto">
                  <v-btn
                    color="primary"
                    class="ml-2"
                    :disabled="!exportData.length"
                  >
                    <download-csv :data="exportData" :name="`${fileName}.csv`">
                      <v-icon dense>mdi-download</v-icon>
                      Export
                    </download-csv>
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="area"
            :search="search"
            loading-text="Loading... Please wait"
            class="elevation-1"
            disable-pagination
            :hide-default-footer="true"
          >
            <template slot="body.append">
              <tr>
                <th>Total</th>
                <template v-if="type === 'All'">
                  <th class="text-center">
                    {{
                      setToLocaleString(getTotal(table.data, `totalLoad`), 2)
                    }}
                  </th>

                  <th class="text-center">
                    {{
                      setToLocaleString(getTotal(table.data, `totalInstall`), 2)
                    }}
                  </th>

                  <th class="text-center">
                    {{
                      setToLocaleString(getTotal(table.data, `initialLoad`), 2)
                    }}
                  </th>
                </template>

                <template v-else>
                  <th class="text-center">
                    {{
                      setToLocaleString(
                        getTotal(table.data, `${camelize("total" + type)}`),
                        2
                      )
                    }}
                  </th>
                </template>
              </tr>
            </template>
            <template
              v-for="header in headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import ShareableMethods from "@/mixins/ShareableMethods";
export default {
  mixins: [ShareableMethods],
  name: "DistributorSales",
  data() {
    return {
      type: "Install",
      types: [
        {
          name: "Install",
          value: "Install",
        },
        {
          name: "Load",
          value: "Load",
        },
        {
          name: "Initial Load",
          value: "Initial Load",
        },
        {
          name: "All",
          value: "All",
        },
      ],

      exportData: [],
      fileName: "",

      menu: false,
      modal: false,
      dates: [
        moment(Date.now()).format("YYYY-MM-DD"),
        moment(Date.now()).format("YYYY-MM-DD"),
      ],
      search: "",
      table: {
        expanded: [],
        singleExpand: false,
        sortBy: "dtCreated",
        sortDesc: true,
        loading: false,

        data: [],
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getList() {
      this.table.loading = true;
      await this.$drs
        .post(`broker/spds/wallet-history`, {
          from: this.dates[0],
          to: this.dates[1],
          walletType: this.type,
        })
        .then((response) => {
          const newArr = response.data.data;

          const self = this;

          if (this.type === "All") {
            this.table.data = newArr.sort(function(a, b) {
              return (
                b["totalLoad"] - a["totalLoad"]
                // a["totalLoad"] - b["totalLoad"]
              );
            });
          } else {
            const field =
              this.type === "Initial Load"
                ? "totalLoad"
                : `${self.camelize("total" + self.type)}`;

            this.table.data = newArr.sort(function(a, b) {
              return b[field] - a[field];
            });
          }
          this.exportExcel(newArr);
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    formatDate(d) {
      return moment(d).format("MMM DD, YYYY");
    },

    getTotal(data, field) {
      const f = field === "totalInitialLoad" ? "totalLoad" : field;
      // console.log(field)
      return data.reduce((partialSum, a) => partialSum + parseFloat(a[f]), 0);
    },

    exportExcel(items) {
      const label = this.type === "All" ? "All Sales" : `${this.type} Sales`;

      let exportData = items.map((item) => {
        if (this.type === "All") {
          return {
            Distributor: item.companyName,
            "Total Load": item.totalLoad,
            "Total Install": item.totalInstall,
            "Initial Load": item.initialLoad,
          };
        } else {
          if (this.type === "Initial Load") {
            return {
              Distributor: item.companyName,
              [`${this.type} Sales`]: item.totalLoad,
            };
          } else {
            return {
              Distributor: item.companyName,
              [`${this.type} Sales`]: item[
                `${this.camelize("total" + this.type)}`
              ],
            };
          }
        }
      });

      if (this.type === "All") {
        exportData.push({
          Distributor: "Total",
          "Total Load": this.sumColumn(exportData, "Total Load"),
          "Total Install": this.sumColumn(exportData, "Total Install"),
          "Initial Load": this.sumColumn(exportData, "Initial Load"),
        });
      } else {
        exportData.push({
          Distributor: "Total",
          [`${this.type} Sales`]: this.sumColumn(
            exportData,
            `${this.type} Sales`
          ),
        });
      }

      this.fileName = `${label}_${this.dates[0]}_${this.dates[1]}`;
      this.exportData = exportData;
    },

    sumColumn(items, prop) {
      console.log(items, prop);
      return items.reduce((a, b) => {
        return a + parseFloat(b[prop]);
      }, 0);
    },

    capitalizedText(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },

    selectedDates(d) {
      this.$refs.dialog.save(d);
      this.getList();
    },

    camelize(str) {
      return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
          return index === 0 ? word.toLowerCase() : word.toUpperCase();
        })
        .replace(/\s+/g, "");
    },
  },

  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    // dates(e) {
    //   if (e.length > 1) {
    //     this.getList();
    //   }
    // },

    type() {
      this.getList();
    },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },

    headers() {
      // const label = this.type === "All" ? "Total Sales" : `${this.type} Sales`;

      const headers = [
        { text: "Distributor", value: "companyName" },
        // { text: label, align: "center", value: "count" },
      ];

      if (this.type === "All") {
        headers.push(
          {
            text: "Recurring Load",
            value: "totalLoad",
            align: "center",
            formatter: (x) => this.setToLocaleString(x),
          },
          {
            text: "Installation",
            value: "totalInstall",
            align: "center",
            formatter: (x) => this.setToLocaleString(x),
          },
          {
            text: "First Bundle Load",
            value: "initialLoad",
            align: "center",
            formatter: (x) => this.setToLocaleString(x),
          }
        );
      } else {
        headers.push({
          text: `Total ${this.type} Sales`,
          value:
            this.type === "Initial Load"
              ? "totalLoad"
              : `${this.camelize("total" + this.type)}`,
          align: "center",
          formatter: (x) => this.setToLocaleString(x),
        });
      }

      return headers;
    },
  },
};
</script>

<style scoped>
.p-0 {
  padding: 0px !important;
}

.sub-areas > div > table > thead > tr {
  background-color: red;
  border-radius: 10px;
}
</style>
